<div class="custom-control custom-checkbox mb-2">
  <input
    [formControlName]="inputName"
    [id]="inputName + index"
    class="custom-control-input"
    type="checkbox"
    (change)="onChange()" />
  <label
    *ngIf="!hideLabel"
    [for]="inputName + index"
    [ngbTooltip]="tooltip"
    class="custom-control-label input-label"
    [innerHTML]="labelName | highlight: highlightText">
  </label>
</div>
